var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24219 3C1.24219 2.03351 2.02569 1.25 2.99219 1.25H20.9922C21.9587 1.25 22.7422 2.03352 22.7422 3V5C22.7422 5.96648 21.9587 6.75 20.9922 6.75H2.99219C2.02569 6.75 1.24219 5.96649 1.24219 5V3ZM2.99219 2.75C2.85412 2.75 2.74219 2.86193 2.74219 3V5C2.74219 5.13807 2.85412 5.25 2.99219 5.25H20.9922C21.1303 5.25 21.2422 5.13808 21.2422 5V3C21.2422 2.86192 21.1303 2.75 20.9922 2.75H2.99219Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24219 11C1.24219 10.0335 2.0257 9.25 2.99219 9.25H20.9922C21.9587 9.25 22.7422 10.0335 22.7422 11V13C22.7422 13.9665 21.9587 14.75 20.9922 14.75H2.99219C2.0257 14.75 1.24219 13.9665 1.24219 13V11ZM2.99219 10.75C2.85411 10.75 2.74219 10.8619 2.74219 11V13C2.74219 13.1381 2.85411 13.25 2.99219 13.25H20.9922C21.1303 13.25 21.2422 13.1381 21.2422 13V11C21.2422 10.8619 21.1303 10.75 20.9922 10.75H2.99219Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24219 19.002C1.24219 18.0354 2.0257 17.252 2.99219 17.252H20.9922C21.9587 17.252 22.7422 18.0354 22.7422 19.002V21.002C22.7422 21.9685 21.9587 22.752 20.9922 22.752H2.99219C2.0257 22.752 1.24219 21.9685 1.24219 21.002V19.002ZM2.99219 18.752C2.85411 18.752 2.74219 18.8639 2.74219 19.002V21.002C2.74219 21.14 2.85411 21.252 2.99219 21.252H20.9922C21.1303 21.252 21.2422 21.14 21.2422 21.002V19.002C21.2422 18.8639 21.1303 18.752 20.9922 18.752H2.99219Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcList);
export default __webpack_public_path__ + "static/media/ic-list.ea8e25d8462a7f8dda73ba319089ed3f.svg";
export { ForwardRef as ReactComponent };